import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/svg/logo-color.svg'


const _hoisted_1 = {
  id: "set-password-container",
  class: "row"
}
const _hoisted_2 = { class: "col-xl-lg-md-sm-xs-12 set-password-panel" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_4 = { class: "mt-20" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" back to login ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "heading mt-20" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Reset Password")
], -1)
const _hoisted_7 = { class: "panel-body" }
const _hoisted_8 = { class: "legend-border" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "EMAIL ADDRESS", -1)
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" cancel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          id: "login-link",
          to: "/login"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _hoisted_6,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("fieldset", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Input, {
                ref: "email",
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                modelModifiers: { trim: true },
                "data-cy": "email",
                type: "email",
                class: "form-control shadow-none",
                placeholder: "Email address *",
                required: "required",
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Input, {
                id: "set-password-button",
                type: "submit",
                class: "btn-submit-reset btn-primary orange",
                value: "Send Email",
                disabled: _ctx.awaitingResponse
              }, null, 8, ["disabled"]),
              _createVNode(_component_router_link, {
                to: _ctx.loginLocation,
                tag: "button",
                type: "button",
                class: "btn-submit-reset btn-submit-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}